var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.87544 5.62505H1.50043C1.30152 5.62505 1.11075 5.54603 0.970099 5.40538C0.829446 5.26472 0.750427 5.07395 0.750427 4.87504V1.50001C0.750427 1.30109 0.829446 1.11033 0.970099 0.969672C1.11075 0.829018 1.30152 0.75 1.50043 0.75H4.87547C5.07438 0.75 5.26515 0.829018 5.4058 0.969672C5.54646 1.11033 5.62548 1.30109 5.62548 1.50001V1.87501",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 0.562506,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50083 3.375H4.1258C3.71158 3.375 3.37579 3.71079 3.37579 4.12501V7.50004C3.37579 7.91426 3.71158 8.25005 4.1258 8.25005H7.50083C7.91505 8.25005 8.25084 7.91426 8.25084 7.50004V4.12501C8.25084 3.71079 7.91505 3.375 7.50083 3.375Z",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 0.562506,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/CopyIcon.47fe00bddfd0ef9b98664067e5382688.svg";
export { ForwardRef as ReactComponent };